// 全局确认指令
// 使用方式：v-confirm="{ text: '提交', confirmText: '确定要提交吗？', callback: submitHandle }"
import Vue from "vue";
export default {
  bind(el, binding) {
    const { text, confirmText, click } = binding.value;
    
    // 保存原始点击事件
    const originalClick = el.onclick;
    const originalText = el.textContent.trim();
    
    // 保存相关数据到元素上
    el._confirmOriginalClick = originalClick;
    el._confirmOriginalText = originalText;
    el._confirmClick = click;
    el._confirmText = text;
    el._confirmConfirmText = confirmText;
    
    // 重写点击事件
    el.onclick = function(event) {
      // 使用Vue.prototype.$confirm来调用
      Vue.prototype.$confirm(el._confirmConfirmText || `确定要${el._confirmText || el._confirmOriginalText ||  "执行此操作"}吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          // 用户确认，执行回调
          if (typeof el._confirmClick === "function") {
            el._confirmClick();
          } else if (el._confirmOriginalClick) {
            // 如果没有提供回调，执行原始点击事件
            el._confirmOriginalClick.call(this, event);
          }
        }).catch(() => {
          // 用户取消，不执行任何操作
        });
    };
  },
  
  update(el, binding) {
    // 当绑定值变化时，更新相关数据
    const { text, confirmText, click } = binding.value;
    el._confirmClick = click;
    el._confirmText = text;
    el._confirmConfirmText = confirmText;
  },
  
  unbind(el) {
    // 解绑时恢复原始点击事件
    el.onclick = null;
    // 清理保存的数据
    delete el._confirmOriginalClick;
    delete el._confirmOriginalText;
    delete el._confirmClick;
    delete el._confirmText;
    delete el._confirmConfirmText;
  },
};
